import React, { useEffect } from "react";
import CloneRepo from "../CodeOverview/CloneRepo.jsx";
import UnitTestResult from "./UnitTestResult.jsx";
import { useSelector, useDispatch } from "react-redux";
import { updateOverview } from "../../state/reducers/codeOverview";

function UnitTest() {

  // const showOverview = useSelector((state) => state.codeOverview.showOverview)
  const showUnitTest = useSelector((state) => state.unitTest.showUnitTest);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateOverview(false))
  }, [])

  return (
    <>
      {!showUnitTest && <CloneRepo />}
      {showUnitTest && <UnitTestResult />}
    </>
  );
}

export default UnitTest;